<template>
  <v-menu
    ref="menu"
    v-model="menu"
    class="date-picker"
    :close-on-content-click="false"
    :disabled="disabled"
    min-width="290px"
    :nudge-right="40"
    offset-y
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <span v-if="hideInput" id="date-picker-icon" v-on="on">
        <mf-icon> keyboard_arrow_down </mf-icon>
      </span>
      <div v-else @click="openMenu">
        <v-text-field
          ref="date-picker-field"
          :value="formattedDate"
          :solo="solo"
          :error-messages="errorMessages"
          :outlined="outlined"
          :disabled="disabled"
          :hide-details="hideDetails"
          :label="label"
          readonly
          :single-line="singleLine"
          class="date-picker-text-field"
          prepend-inner-icon="calendar_today"
          :class="menu ? 'blue-icon' : 'grey-icon'"
          :append-icon-cb="openMenu"
          :dense="dense"
          v-on="on"
        />
      </div>
    </template>
    <v-date-picker v-model="computedDate" :type="type" locale="pt-BR" :max="max" :min="min" @input="input" />
  </v-menu>
</template>

<script>
import { capitalize } from 'lodash'

export default {
  props: {
    label: String,
    date: String,
    singleLine: Boolean,
    max: String,
    min: String,
    icon: Boolean,
    outlined: Boolean,
    hideDetails: Boolean,
    solo: Boolean,
    disabled: Boolean,
    errorMessages: [Array, String],
    type: String,
    hideInput: Boolean,
    appendIcon: {
      type: Boolean,
      default: true,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    menu: false,
  }),
  computed: {
    computedDate: {
      get() {
        if (!this.date) return null
        return this.date.split('T')[0]
      },
      set(value) {
        this.$emit('update:date', value)
      },
    },
    formattedDate() {
      if (!this.date) return ' - '
      return this.formatDate(this.date)
    },
    iconName() {
      if (this.icon) return 'event'
      return ''
    },
  },
  methods: {
    openMenu(event) {
      const value = event.target.classList['value']
      if (['v-text-field__slot', 'v-input__slot'].includes(value) || value.includes('v-icon')) {
        this.menu = true
      }
    },
    formatDate(date) {
      if (!date) return null
      if (this.type === 'month') {
        return capitalize(
          this.$luxon(date.toString(), {
            input: {
              format: 'yyyy-MM',
            },
            output: {
              format: "MMMM 'de' yyyy",
            },
          })
        )
      }
      return this.$luxon(date.toString(), {
        input: {
          format: 'yyyy-MM-dd',
        },
        output: {
          format: 'dd/MM/yyyy',
        },
      })
    },
    input(value) {
      this.$emit('input', value)
      this.menu = false
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .v-text-field__details {
  margin: 0 !important;
  padding: 0 !important;
}

.v-text-field__details {
  padding-left: 0 !important;
}

#date-picker-icon {
  height: 24px;
}
.v-text-field__details {
  padding-left: 0 !important;
}
.error-message {
  color: #e03210;
}
.date-picker-text-field {
  ::v-deep .v-text-field__slot,
  ::v-deep .v-input__slot,
  ::v-deep i,
  ::v-deep input,
  ::v-deep fieldset {
    cursor: pointer !important;
  }
}
.date-picker-text-field.v-input--dense {
  ::v-deep i {
    font-size: 20px;
  }
}
.grey-icon {
  ::v-deep .v-icon {
    color: #6b7580 !important;
  }
}
.blue-icon {
  ::v-deep .v-icon {
    color: #002040 !important;
  }
}

::v-deep input {
  // remove o evento de click default do input e passa a considerar como o v-input__slot
  pointer-events: none !important;
}
</style>
